























































import { Component, Vue, Mixins } from 'vue-property-decorator'
import Default from './Default.vue'

@Component
export default class Versus extends Mixins(Default) {
  /**
   * Active.
   */
  public active: number = 0

  /**
   * On mounted hook
   */
  mounted() {
    //@ts-ignore
    if (this.slide.options.arrows) {
      let i = 1
      const interval = setInterval(() => {
        this.active = i
        i++
        //@ts-ignore
        if (i === this.slide.options.arrows.length) {
          clearInterval(interval)
        }
      }, 1250)
    }
  }
}
